import React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar } from '@mui/material';
import clsx from 'clsx';
import { PAY_MAX_WIDTH } from 'pages/pay';

const PREFIX = 'PayHeader';

const classes = {
    appBar: `${PREFIX}appBar`,
    marginBlock: `${PREFIX}marginBlock`,
    small: `${PREFIX}small`,
    large: `${PREFIX}large`
};

const Root = styled('div')(({ theme }) => ({
    [`& .${classes.appBar}`]: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.primary.main,
        padding: theme.spacing(1, 2, 0, 2),
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: PAY_MAX_WIDTH
    },

    [`& .${classes.marginBlock}`]: {
        height: '128px',
        flexShrink: 0,
        width: '100%'
    },

    [`& .${classes.small}`]: {
        height: '72px'
    },

    [`& .${classes.large}`]: {
        height: '168px'
    }
}));

interface PayHeaderProps {
    variant?: 'default' | 'small' | 'large';
}

export const PayHeader: React.FC<React.PropsWithChildren<PayHeaderProps>> = ({
    children,
    variant = 'default'
}) => (
    <Root>
        <div
            className={clsx(classes.marginBlock, {
                [classes.small]: variant === 'small',
                [classes.large]: variant === 'large'
            })}
        />
        <AppBar position="fixed" elevation={0} className={classes.appBar}>
            {children}
        </AppBar>
    </Root>
);
